import { Alert } from '@mui/material';
import React, { useContext } from 'react';
import { StoreHeaderDataContext } from '../../../context-api/StoreHeaderDataProvider';
import MAP_ZIPCODE from "../../../global/assets/svg/MapZipcode.svg";
import { ENTER_ZIPCODE_WITH_US } from '../../../global/constants';
import AtomicButton from '../../button/AtomicButton';
import InputBox from '../../inputbox/InputBox';
import "./ZipCodeCheckerMobile.scss";

const zipCodeValidator = (zip) => /^[0-9]{5}$/.test(zip);

export const ZipCodeCheckerMobile = () => {
    const dataContext = useContext(StoreHeaderDataContext);
    const {
        kitchensByZipcode,
        onGetKitchenByZipcode,
        setKitchensByZipcode,
        clearZipcodeFromLocalStorage,
        zipcode,
        setZipcode,
    } = dataContext;

    const {
        zipcode: localStorageZipcode,
        error,
        loading,
        success,
    } = kitchensByZipcode;

    const zipCodeHandler = (e) => {
        const { value } = e.target;
        if (value.length < 6 && value.trim() !== "") {
            setZipcode(value);
        } else if (value.length === 0) {
            setZipcode("");
        }
        setKitchensByZipcode({
            ...kitchensByZipcode,
            success: true,
            error: "",
            totalKitchens: 0,
        });
    };
    const isZipValid = zipCodeValidator(zipcode);
    const showZipError = !isZipValid;

    const onSubmitHandler = () => {
        if (isZipValid) {
            setZipcode(zipcode)
            onGetKitchenByZipcode(zipcode);
        }
    };

    const apiError =
        error.length > 0 ? (
            <Alert id="alert-box" sx={{ border: "none" }} severity="error">
                Network error,Please try again!
            </Alert>
        ) : (
            ""
        );

    return (
        <div className="zipcode-checker-mobile-container">
            <img src={MAP_ZIPCODE} alt="" />
            <div className="zipcode-text">
                {ENTER_ZIPCODE_WITH_US}
            </div>
            <div style={{
                marginBottom: '25px',
                fontFamily: 'Inter Regular',
                fontSize: '14px',
                color: 'gray'
            }}> Discover Delicious & Affordable Combo Meals Nearby</div>
            {apiError}
            <InputBox
                // autoFocus={autoFocus}
                type="number"
                label="Enter Zipcode"
                size={"medium"}
                width={"auto"}
                height="auto"
                name="zipcode"
                onChange={zipCodeHandler}
                error={zipcode.length > 0 && showZipError}
                inputErrorMsg={
                    zipcode.length > 0 && showZipError ? "Invalid Zip Entered" : ""
                }
                inputProps={{ maxLength: 6, pattern: "d{1,6}" }}
                value={zipcode}
                showLoader={loading}
            />
            <AtomicButton
                label="FIND FOOD"
                loading={loading}
                style={{ marginTop: "10px" }}
                handleSubmit={onSubmitHandler}
            />
        </div>
    )
}
